import { Component, OnInit } from '@angular/core';
import {SensorService} from "../../services/sensor.service";
import {sensor} from "../../models/sensor";
import {ProyectoService} from "../../services/proyecto.service";
import {Navigation} from "../../services/navigation.service";
import {Localiser} from "../../services/localiser";

@Component({
  selector: 'app-limits',
  templateUrl: './limits.component.html',
  styleUrls: ['./limits.component.css']
})
export class LimitsComponent implements OnInit {

  sensores: sensor[];
  sensorSelect: sensor = null;
  nombre: string = "";
  unidadMedida: string = "";
  equivalencia4mA: number = 0;
  equivalencia20mA: number = 0;
  umbralBajo: number = 0;
  umbralAlto: number = 0;
  enabledUmbralBajo: boolean = true;
  enabledUmbralAlto: boolean = true;
  descripcion: string = "";

  actualizado: boolean = false;

  get hasSensorSelected(): boolean {
    return this.sensorSelect != null;
  }

  constructor(private sensorService: SensorService, public proyectoService: ProyectoService,
              public navigation: Navigation, public localiser: Localiser) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("limits");
      this.toLocations();
    }  else {
      proyectoService.setLastPage("limits")
    }
  }

  ngOnInit(): void {
    this.getSensores();
  }

  getSensores() {
    this.sensorService.getSensores420ByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.sensores = <Array<sensor>> result;
      this.sensorSelect = this.sensorService.getSensorToEdit();
      this.selectSensor(this.sensorSelect);
      this.sensorService.setSensorToEdit(null);
    });
  }

  selectSensor(sensor: sensor) {
    if (sensor != null) {
      this.nombre = sensor.nombre;
      this.unidadMedida = sensor.unidadMedida;
      this.equivalencia4mA = sensor.equivalencia4mA;
      this.equivalencia20mA = sensor.equivalencia20mA;
      this.umbralBajo = sensor.umbralBajo;
      this.umbralAlto = sensor.umbralAlto;
      this.enabledUmbralBajo = sensor.enabledUmbralBajo;
      this.enabledUmbralAlto = sensor.enabledUmbralAlto;
      this.descripcion = sensor.descripcion;
    }
  }

  updateSensorInfo() {
    if (!this.hasSensorSelected) {
      return;
    }

    this.sensorSelect.nombre = this.nombre;
    this.sensorSelect.unidadMedida = this.unidadMedida;
    this.sensorSelect.equivalencia4mA = this.equivalencia4mA;
    this.sensorSelect.equivalencia20mA = this.equivalencia20mA;
    this.sensorSelect.umbralBajo = this.umbralBajo;
    this.sensorSelect.umbralAlto = this.umbralAlto;
    this.sensorSelect.enabledUmbralBajo = this.enabledUmbralBajo;
    this.sensorSelect.enabledUmbralAlto = this.enabledUmbralAlto;
    this.sensorSelect.descripcion = this.descripcion;

    this.sensorService.updateSensor(this.sensorSelect).subscribe(result => {
      this.actualizado = true;
      let that = this;
      setTimeout(function () {
        that.actualizado = false;
        console.log("time")
      }, 2500);
    }, error => {
      this.actualizado = true;
      let that = this;
      setTimeout(function () {
        that.actualizado = false;
        console.log("time")
      }, 2500);
    })
  }

  maxLengthCheckEq4(event) {
    if (event.target.value.length > event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);
      event.target.value = +number;
      this.equivalencia4mA = +number;
    }
  }

  maxLengthCheckEq20(event) {
    if (event.target.value.length > event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);
      event.target.value = +number;
      this.equivalencia20mA = +number;
    }
  }

  maxLengthCheckUmbralBajo(event) {
    if (event.target.value.length > event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);
      event.target.value = +number;
      this.umbralBajo = +number;
    }
  }

  maxLengthCheckUmbralAlto(event) {
    if (event.target.value.length > event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);
      event.target.value = +number;
      this.umbralAlto = +number;
    }
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
